import { Td, Text } from '@pancakeswap/uikit'
import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import ResultAvatar from './ResultAvatar'
import { NetWinnings } from './styles'

interface DesktopRowProps {
  rank?: number
  user: PredictionUser
}

const StyledTd = styled(Td)`
  padding: 8px 24px 8px 0;
`

const StyledTr = styled.tr`
  border-radius: 12px;
  background: var(--Nature-1, #191b2e);

  padding: 8px 16px;

  td:first-child {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  td:last-child {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`

const DesktopRow: React.FC<React.PropsWithChildren<DesktopRowProps>> = ({ rank, user, ...props }) => (
  <StyledTr {...props}>
    {rank ? (
      <StyledTd style={{ paddingRight: '24px', paddingLeft: '0' }}>
        <Text textAlign="center" color="white" fontWeight={700}>{`#${rank}`}</Text>
      </StyledTd>
    ) : (
      <StyledTd />
    )}
    <StyledTd>
      <ResultAvatar user={user} />
    </StyledTd>
    <StyledTd>
      <NetWinnings
        fontWeight="700"
        fontSize="14px"
        subFontWeight="400"
        subFontSize="12px"
        amount={user.netETH}
        textPrefix={user.netETH > 0 ? '+' : ''}
        textColor={user.netETH > 0 ? 'success' : 'failure'}
        flexDirection="column"
        alignItems="flex-start"

        // amount={user.netBNB}
        // textPrefix={user.netBNB > 0 ? '+' : ''}
        // textColor={user.netBNB > 0 ? 'success' : 'failure'}
      />
    </StyledTd>
    <StyledTd fontSize="14px" fontWeight="700">
      {/* {`${user.winRate.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })}%`} */}
      {`${parseFloat(
        user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
      ).toFixed(2)}%`}
    </StyledTd>
    <StyledTd fontSize="14px" fontWeight="700">
      {user.totalBetsClaimed.toLocaleString()}
    </StyledTd>
    <StyledTd fontSize="14px" fontWeight="700">
      {user.totalBets.toLocaleString()}
    </StyledTd>
  </StyledTr>
)

export default DesktopRow
